import React from 'react';
import { Avatar, Box } from '@chakra-ui/react';
import { getColor } from '../utils/colorUtils';
import { getTeamAbbreviation } from '../utils/getTeamInfo';

interface TeamLogoProps {
  team: {
    name: string;
    abbreviation?: string;
    logo?: string | null;
    color_primary?: string | null;
    color_secondary?: string | null;
    color_text?: string | null;
  };
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const TeamLogo: React.FC<TeamLogoProps> = ({ team, size = 'md' }) => {
  const getInitials = () => {
    // Use abbreviation if available, otherwise fall back to name
    const abbreviation = getTeamAbbreviation(team);
    if (abbreviation) {
      return abbreviation.split(' ')[0].toUpperCase().substring(0, 3);
    }
    if (!team.name) return '';
    return team.name.substring(0, 3).toUpperCase();
  };

  // Size mappings
  const sizeMap = {
    sm: { fontSize: '0.7rem', box: '36px', px: 0.5, border: '2px' },
    md: { fontSize: '0.9rem', box: '44px', px: 1, border: '3px' },
    lg: { fontSize: '1.1rem', box: '56px', px: 1.5, border: '4px' },
    xl: { fontSize: '1.8rem', box: '100px', px: 2.5, border: '6px' },
  };
  const s = sizeMap[size] || sizeMap['md'];

  const bg = getColor(team.color_primary, '#222');
  const border = getColor(team.color_secondary, '#fff');
  const text = getColor(team.color_text, '#fff');

  if (team.logo && team.logo.startsWith('http')) {
    return (
      <Avatar size={size} src={team.logo} name={team.name} />
    );
  }

  // Custom avatar with colored border and text
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      border={`${s.border} solid ${border}`}
      bg={bg}
      color={text}
      fontWeight="bold"
      fontSize={s.fontSize}
      width={s.box}
      height={s.box}
      px={s.px}
    >
      {getInitials()}
    </Box>
  );
};

export default TeamLogo; 